import React, { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import clsx from 'clsx'
import { useAuth0 } from '@auth0/auth0-react'
import { resetIdentity } from '../../../analytics/tracking'

import { setAuth, setViewingUserId } from '../../../state/appSlice'
import { cookies, CookieType } from '../../../state/cookies'
import { useAppDispatch } from '../../../state/hooks'
import { createPortal } from 'react-dom'

interface AccountLockupProps {
  user: {
    firstName?: string | null
    lastName?: string | null
  }
  expanded?: boolean
}
export const AccountLockup = ({ user, expanded }: AccountLockupProps) => {
  const { logout } = useAuth0()
  const dispatch = useAppDispatch()
  const onLogoutClick = () => {
    logout({ returnTo: window.location.origin })
    resetIdentity()

    cookies.remove(CookieType.AUTH)
    cookies.remove(CookieType.VIEWING_USER)
    dispatch(setAuth(undefined))
    dispatch(setViewingUserId(undefined))
  }
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="w-full flex items-center space-x-2 rounded-lg hover:bg-primary-light transition-colors justify-start">
        <div className="w-10 h-10 flex-shrink-0 bg-gray-500 text-white text-base font-bold flex items-center justify-center rounded-full leading-none align-middle pt-1">
            {user.firstName?.[0]}{user.lastName?.[0]}
          </div>
        </Menu.Button>
      </div>

      <Transition
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <div>
          {createPortal(
            <Menu.Items className="absolute bottom-12 left-14 z-50 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={onLogoutClick}
                      type="button"
                      className={clsx(
                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                        'block w-full px-4 py-2 text-left text-sm'
                      )}
                    >
                      Sign out
                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>,
            document.body // Render at the root level of the DOM
          )}
        </div>
      </Transition>

    </Menu>
  )
}
